import { DateUtils, Role } from "@cuatroochenta/co-admin-react-library";
import { CustomResponse } from "../model/data/common";
import { Event } from "../model/domain/event";
import TaskBase from "./TaskBase";
import Urls from "./Urls";

export default class TaskCalendar extends TaskBase {

    public getEvents(rangeStartDate: Date, rangeEndDate: Date): Promise<Event[]> {
        const formattedRangeStartDate = DateUtils.formatDateForQueryString(rangeStartDate)
        const formattedRangeEndDate = DateUtils.formatDateForQueryString(rangeEndDate)

        return fetch(
            `${Urls.URL_GET_EVENTS}?range_start_date=${formattedRangeStartDate}&range_end_date=${formattedRangeEndDate}&center_id=${this.selectedCenter}&role_id=${Role.ADMIN}`,
            this.getRequestInfo()
        )
            .then(response => response.json())
            .then((response: CustomResponse<Event[]>) => {
                if (!response.success) {
                    throw new Error(response.error?.[0])
                }

                return response.data!
            })
            .catch(error => {
                console.error('Error fetching events:', error);
                throw error;
            });
    }

    public getEventDetail(eventId: number): Promise<Event> {
        return fetch(
            `${Urls.URL_GET_EVENTS}/${eventId}`,
            this.getRequestInfo()
        )
            .then(response => response.json())
            .then((response: CustomResponse<Event>) => {
                if (!response.success) {
                    throw new Error(response.error?.[0])
                }

                return response.data!
            })
            .catch(error => {
                console.error('Error fetching event detail:', error);
                throw error;
            });
    }

    public saveEvent(event: Event) {
        const formData = new FormData();

        const presentValues = Object
            .entries(event)
            .filter(([_, value]) => value != null && `${value}`.length)
        for (const [key, value] of presentValues) {
            formData.append(
                key,
                Array.isArray(value)
                    ? JSON.stringify(value)
                    : value
            )
        }

        let url = Urls.URL_GET_EVENTS
        if (event.id) {
            url += `/${event.id}`
        }

        return fetch(url, {
            ...this.getRequestInfo(),
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then((response: CustomResponse<void>) => {
            if (!response.success) {
                throw new Error(response.error?.[0])
            }
        })
        .catch(error => {
            console.error('Error creating event:', error);
            throw error;
        });
    }

    public deleteEvent(eventId: number) {
        return fetch(`${Urls.URL_GET_EVENTS}/${eventId}`, {
            ...this.getRequestInfo(),
            method: 'DELETE'
        })
            .then(response => response.json())
            .then((response: CustomResponse<void>) => {
                if (!response.success) {
                    throw new Error(response.error?.[0])
                }
            })
            .catch(error => {
                console.error('Error deleting event:', error);
                throw error;
            });
    }

}